<template>
  <div class="standard-checkout">
    <div class="d-flex flex-row align-content-center container-back">
      <button class="bg-transparent border-0" @click="$emit('cancel')">
        <i class="icon-angle-left"></i>
      </button>
      <h1 class="page-title">
        Pré-visualizar Checkout Padrão
        <small
          >Você está visualizando o modelo padrão de checkout da Blitzpay. Todos
          os dados preenchidos são fictícios.</small
        >
      </h1>
    </div>

    <hr class="mb-6" />

    <div class="row">
      <div class="col-lg-8">
        <standard-checkout-form />
      </div>
      <div class="col-lg-4 ">
        <standard-checkout-details />
      </div>
    </div>
  </div>
</template>

<script>
import StandardCheckoutDetails from "./StandardCheckoutDetails";
import StandardCheckoutForm from "./StandardCheckoutForm";

export default {
  components: { StandardCheckoutForm, StandardCheckoutDetails }
};
</script>

<style lang="scss" scoped>
.standard-checkout {
  .container-back {
    button {
      margin-right: 16px;
      position: relative;
    }

    i {
      position: absolute;
      font-size: 24px;
      max-width: 24px;
      top: 6.8%;
      cursor: pointer;
    }
  }

  ::v-deep .card {
    border-radius: 16px;

    .card-title {
      border-radius: 16px 16px 0px 0px;
      min-height: 57px;
      max-height: 57px;
    }
  }
}
</style>
